import React, { memo } from 'react';

import { OrderWithItemsAndSummary, OrderConfirmed } from 'components';

const PageOrderConfirmed = memo(() => {
  return (
    <OrderWithItemsAndSummary
      hideSummaryBox
      titleId={'pages.order.confirmed.title'}
    >
      <OrderConfirmed />
    </OrderWithItemsAndSummary>
  );
});

PageOrderConfirmed.displayName = 'PageOrderConfirmed';

export { PageOrderConfirmed };
